import UploadedFile from './UploadedFile';
export default UploadedFile;
